<template>
  <div class="LC_monitorPoints" ref="LC_monitorPoints" @click="rowClick()">
    <div class="monitorPointsBg"></div>
    <ul>
      <li v-for="(item, i) in dataList" :key="i">
        <div class="li_name">
          {{ item.carbonTypeName }}
        </div>
        <div class="li_count number" :style="{ color: countColor(i) }">
          {{ item.carbonNum }}
        </div>
      </li>
    </ul>
  </div>
</template>



<script>
import lowCarbonPopup2 from "@/modules/lowcarbonComponents/lowCarbonPopup2/indexNew.vue";
import { mapGetters } from "vuex";
export default {
  props: ["matrix", "x", "y"],
  components: {
    lowCarbonPopup2,
  },
  data() {
    return {
      pageInfo: 'LC_monitorPoints.vue',
      computedName: '碳排放监控点位组件',
      customerId: this.$store.state.customerId,
      dataList: [],
      setTime1: null,
    };
  },
  computed: {
    countColor() {
      return (i) => {
        if (i == 0) {
          return "#f4d29c";
        } else if (i == 1) {
          return "#8de4f3";
        } else if (i == 2) {
          return "#b6ffc6";
        } else {
          return "rgb(255, 115, 115)";
        }
      };
    },
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },

  watch: {},

  created() {},

  mounted() {
    let that = this;
    let w = $(that.$refs.LC_monitorPoints).outerWidth();
    let h = $(that.$refs.LC_monitorPoints).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
  },
  methods: {
    rowClick() {
      //console.log("sss", i);
      this.$store.commit("dialogStatus", true);
      this.$popup.open(lowCarbonPopup2, this.dialogCompontent, {
        pageTitleName: "碳排放监控点位",
      });
    },
    async getListData() {
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      try {
        const getCarbonEmissionType =
          CONFIG.requestName + this.$apiOpt.getCarbonEmissionType;
        let res = await this.$apiUtils.get(getCarbonEmissionType, {
          customerId: this.customerId,
        });

        this.dataList = res;
      } catch (err) {
        console.log(err);
      }
      this.setTime1 = setTimeout(() => {
        this.getListData();
      }, 60 * 1000 * 30);
    },
  },
};
</script>



<style lang="scss" scoped="scoped">
.LC_monitorPoints {
  height: 250px;
  width: 600px;
  .monitorPointsBg {
    @include bg-box(560px, 178px, "wrapbg.png");
    margin-top: 32px;
    position: absolute;
    z-index: -1;
  }
  ul {
    margin-top: 32px;
    padding: 20px;
    height: 178px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    li {
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      @include bg-box(512px, 30px, "libg.png");
      margin-bottom: 6px;
      padding-left: 10px;
      padding-right: 16px;
      align-items: center;
      .li_name {
        font-size: 16px;
        font-weight: 600;
        color: #c8d8ff;
        line-height: 30px;
      }
      .li_count {
        font-size: 22px;
        font-weight: 400;
        color: #f4d29c;
        line-height: 30px;
      }
    }
  }
}
</style>
